// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"552":"0a45e2ca","789":"1da9e994","820":"66d6080d","837":"360ef8cc"}[chunkId] + ".chunk.js";
};